import { render, staticRenderFns } from "./MarathonCard.vue?vue&type=template&id=1a5e5dc3&scoped=true&"
import script from "./MarathonCard.vue?vue&type=script&lang=js&"
export * from "./MarathonCard.vue?vue&type=script&lang=js&"
import style0 from "./MarathonCard.vue?vue&type=style&index=0&id=1a5e5dc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5e5dc3",
  null
  
)

export default component.exports